import { Controller } from "@hotwired/stimulus";

var HubInstructionsController = class extends Controller {
  select(event) {
    event.preventDefault();
    const id = event.currentTarget.dataset.sectionId;

    this.navItemTargets.forEach((item) => {
      item.classList.toggle("is-active", item.dataset.sectionId === id);
    });

    this.sectionTargets.forEach((section) => {
      section.classList.toggle("is-active", section.id === id);
    });

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.hidden = true;
    }
  }
};

HubInstructionsController.targets = ["navItem", "section", "placeholder"];

export default HubInstructionsController;
